import { render, staticRenderFns } from "./Nav.vue?vue&type=template&id=270a54ed&scoped=true"
import script from "./Nav.vue?vue&type=script&lang=js"
export * from "./Nav.vue?vue&type=script&lang=js"
import style0 from "./Nav.vue?vue&type=style&index=0&id=270a54ed&prod&lang=scss"
import style1 from "./Nav.vue?vue&type=style&index=1&id=270a54ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270a54ed",
  null
  
)

export default component.exports